export default __webpack_public_path__ + "static/media/kcfl.582b84c3.jpg";